import axios from "axios";
import config from "../config";
import main from "../main";
import utils from "../utils";
import store from "../store";
import global from "../components/Global.vue";

axios.defaults.timeout = 10 * 60 * 1000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencode";
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = 'https://mysystemapi.dinsafer.com'
// axios.defaults.withCredentials = true
// {'Content-Type':'application/x-www-form-urlencode'}
// axios.defaults.responseType = 'json'
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // 这里我们把错误信息扶正, 后面就不需要写 catch 了
    return Promise.resolve(error.response);
  }
);

var CancelToken = axios.CancelToken;
var source = CancelToken.source();

function checkCode(res) {
  // user no login
  if (res && res.data && res.data.Status === -12) {
    main.logout();
  }
  return res;
}

export default {
  request(method, uri, data = null) {
    if (!method) {
      console.error("API function call requires method argument");
      return;
    }

    if (!uri) {
      console.error("API function call requires uri argument");
      return;
    }

    var url = config.serverURI + uri;
    return axios({ method, url, data }).then(checkCode);
  },
  requestWithServerUrl(method, serverurl, uri, data = null) {
    if (!method) {
      console.error("API function call requires method argument");
      return;
    }

    if (!uri) {
      console.error("API function call requires uri argument");
      return;
    }

    var url = serverurl + uri;
    return axios({ method, url, data }).then(checkCode);
  },
  uploadFile(file, token, progress, finish) {
    var that = this;
    //          获取上传token
    var params = new URLSearchParams();
    params.append("token", token);
    this.requestWithServerUrl(
      "post",
      config.blackholeServerURI,
      "/uploader/getuptokenv2",
      params
    ).then(response => {
      var data = response.data;
      if (data.Status !== 1) {
        finish("", false);
        return;
      }
      if (data.Result) {
        that.toDoUploadFile(data.Result, file, progress, finish);
      } else {
        finish("", false);
      }
    });
  },
  toDoUploadFile(token, file, progress, finish) {
    // 创建form对象
    let param = new FormData();
    // 通过append向form对象添加数据
    param.append("file", file, file.name);
    // 添加form表单中其他数据
    param.append("chunk", "0");
    param.append("token", token);
    // FormData私有类对象，访问不到，可以通过get判断值是否传进去
    //        console.log(param.get('file'))
    // 添加请求头
    let config = {
      headers: { "Content-Type": "multipart/form-data" },
      cancelToken: source.token,
      onUploadProgress: function(e) {
        var p = Math.round((e.loaded * 100) / e.total) || 0;
        progress(p);
      }
    };
    axios
      .post("https://upload.qiniu.com/", param, config)
      .then(response => {
        var data = response.data;
        if (data) {
          finish(data.key, true, false);
        } else {
          finish("", false, false);
        }
        progress(0);
      })
      .catch(function(thrown) {
        // if (axios.isCancel(thrown)) {
        // console.log('Request canceled', thrown.message)
        progress(0);
        finish("", false, true);
        // } else {
        // handle error
        // }
      });
  },
  cancelUpload() {
    source.cancel("");
  },
  async post({ path, data, withLoading, noError }) {
    if (process.env.NODE_ENV === "development") {
      console.log(`--> [${path}]:`, data);
    }

    const params = new URLSearchParams();
    params.append(
      "json",
      utils.getRC4Hex(JSON.stringify(data), global.APP_SECRET)
    );
    if (window.localStorage) {
      params.append("token", window.localStorage.getItem("token"));
    }

    withLoading && store.commit("SET_FULLSCREEN_LOADING");
    const url = config.serverURI + path;

    try {
      const res = await axios({ method: "post", url, data: params }).then(
        checkCode
      );

      withLoading && store.commit("UNSET_FULLSCREEN_LOADING");

      const { Status, Result, ErrorMessage } = res.data;
      /* Checking if error object was returned from the server */
      if (Status === 1 && Result) {
        const respData = JSON.parse(
          utils.getDecodeRC4Hex(Result, global.APP_SECRET)
        );
        if (process.env.NODE_ENV === "development") {
          console.log(`<-- [${path}]:`, respData);
        }
        return respData;
      } else {
        throw new Error(ErrorMessage || "Unkonwn Error");
      }
    } catch (err) {
      withLoading && store.commit("UNSET_FULLSCREEN_LOADING");
      if (!noError) store.commit("SET_ERROR", err.message);
      throw err;
    }
  },
  async post_blackhole({
    path,
    appid,
    cmd,
    data,
    withLoading,
    noError,
    host = config.blackholeServerURI
  }) {
    const params = new URLSearchParams();
    params.append(
      "json",
      JSON.stringify({ ...data, messageid: utils.getMessageId(), cmd })
    );
    if (window.localStorage) {
      params.append("token", window.localStorage.getItem("token"));
    }

    withLoading && store.commit("SET_FULLSCREEN_LOADING");
    const url = host + path + "/" + appid;

    try {
      const res = await axios({ method: "post", url, data: params });
      withLoading && store.commit("UNSET_FULLSCREEN_LOADING");
      const data = res.data || {};
      const { Status, ErrorMessage } = data;
      if (Status !== 1) {
        throw new Error(ErrorMessage || "Unknown Error");
      }
      return data;
    } catch (err) {
      withLoading && store.commit("UNSET_FULLSCREEN_LOADING");
      if (!noError) store.commit("SET_ERROR", err.message);
      throw err;
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/index.js